export const FETCH_PERMISSIONS_BEGIN = "FETCH_PERMISSIONS_BEGIN";
export const FETCH_PERMISSIONS_SUCCESS = "FETCH_PERMISSIONS_SUCCESS";
export const FETCH_PERMISSIONS_FAILURE = "FETCH_PERMISSIONS_FAILURE";
export const FETCH_AVAILABLE_ACCOUNTS_BEGIN = "FETCH_AVAILABLE_ACCOUNTS_BEGIN";
export const FETCH_AVAILABLE_ACCOUNTS_SUCCESS = "FETCH_AVAILABLE_ACCOUNTS_SUCCESS";
export const FETCH_AVAILABLE_ACCOUNTS_FAILURE = "FETCH_AVAILABLE_ACCOUNTS_FAILURE";
export const FETCH_AVAILABLE_GROUPS_BEGIN = "FETCH_AVAILABLE_GROUPS_BEGIN";
export const FETCH_AVAILABLE_GROUPS_SUCCESS = "FETCH_AVAILABLE_GROUPS_SUCCESS";
export const FETCH_AVAILABLE_GROUPS_FAILURE = "FETCH_AVAILABLE_GROUPS_FAILURE";
export const FETCH_AVAILABLE_INHERITED_GROUPS_BEGIN = "FETCH_AVAILABLE_INHERITED_GROUPS_BEGIN";
export const FETCH_AVAILABLE_INHERITED_GROUPS_SUCCESS = "FETCH_AVAILABLE_INHERITED_GROUPS_SUCCESS";
export const FETCH_AVAILABLE_INHERITED_GROUPS_FAILURE = "FETCH_AVAILABLE_INHERITED_GROUPS_FAILURE";
